import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {TextBoxComponent} from "@syncfusion/ej2-vue-inputs";
import {computed} from "vue";
import {ref} from "vue";
import getGuid from "@/shared/utils/getGuid";

interface Props {
  autocomplete?: string,
  placeholder?: string,
  modelValue?: string,
  maxLength?: number | string,
  minLength?: number | string,
  name?: string
  intervalModified?: () => void
  intervalLength?: number
  interval?: number
  type?: string
  width?: string
  multiline?: boolean

//  dataMsgContainerId:string|undefined
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogTextBox',
  props: {
    autocomplete: { default: "on" },
    placeholder: { default: undefined },
    modelValue: { default: undefined },
    maxLength: { default: undefined },
    minLength: { default: undefined },
    name: { default: undefined },
    intervalModified: { type: Function, default: undefined },
    intervalLength: { default: 3 },
    interval: { default: 1000 },
    type: { default: undefined },
    width: { default: "160px" },
    multiline: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emits = __emit;
/*
const emit = defineEmits(['update:modelValue'])
*/
const _input = ref<InstanceType<typeof TextBoxComponent> | null>(null)
const _interval = ref<number | undefined>(undefined)
const _key = ref("")


const autocompleteValue = computed(() => {
  return props.autocomplete === "false" || props.autocomplete === "off" ? "off" : "on"
})

const focus = () => {
  _input.value?.focusIn();
}

__expose({
  focus
})

/*
watch(props.modelValue,()=>{
  console.log("watch");
})
*/

const _style = computed<string>(() => props.width ? "width: " + props.width : "")

function onInput(args: any) {
  emits("update:modelValue", args.value)
  if (props.intervalModified) {
    if (_interval.value) {
      clearInterval(_interval.value)
    }
    _key.value = getGuid();
    if (args.value.length > 0 && args.value.length < props.intervalLength)
      return
    _interval.value = setInterval(async (key: string) => {
      if (_interval.value) {
        clearInterval(_interval.value)
      }
      if (key !== _key.value)
        return;
      if (props.intervalModified)
        props.intervalModified();
    }, props.interval, _key.value)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_style.value)
  }, [
    _createVNode(_unref(TextBoxComponent), {
      ref_key: "_input",
      ref: _input,
      "float-label-type": "Always",
      placeholder: __props.placeholder,
      value: __props.modelValue,
      autocomplete: autocompleteValue.value,
      "max-length": __props.maxLength,
      "min-length": __props.minLength,
      "icon-css": "e-search-icon",
      name: __props.name,
      type: __props.type,
      multiline: __props.multiline,
      onInput: onInput
    }, null, 8, ["placeholder", "value", "autocomplete", "max-length", "min-length", "name", "type", "multiline"])
  ], 4))
}
}

})